const MutationType = {};

MutationType.PUSH = 'push';
MutationType.UNSHIFT = 'unshift';
MutationType.POP = 'pop';
MutationType.DELETE_KEY = 'delete_key';

export default MutationType;
